<article class="ui-contact-card">
  <div class="ui-contact-card__person">
    <ui-avatar
      [imageSrc]="photo() || null"
      [imageAlt]="name()"
      [label]="name()"
      size="lg"
    />
    <div class="ui-contact-card__copy">
      <p class="ui-contact-card__name">{{ name() }}</p>
      <p class="ui-contact-card__role">{{ role() }}</p>
      @if (email()) {
        <p class="ui-contact-card__detail">{{ email() }}</p>
      }
      @if (phone()) {
        <p class="ui-contact-card__detail">{{ phone() }}</p>
      }
    </div>
  </div>

  <div class="ui-contact-card__actions">
    <ui-button
      variant="white"
      size="sm"
      [block]="true"
      iconSrc="/icons/ic_message.svg"
    >
      Mensaje
    </ui-button>
    <ui-button
      variant="white"
      size="sm"
      [block]="true"
      iconSrc="/icons/ic_mail.svg"
    >
      Correo
    </ui-button>
  </div>
</article>
